const data = {
  id: "equity",
  title: "The Two Huntsvilles",
  intro: "Why does it cost more to be poor in Huntsville? Why do schools three miles apart produce outcomes decades apart? The disparities across Huntsville, Madison, and the surrounding county aren't random — they were built, budgeted, and decided.",
  tabs: [
    {
      id: "overview",
      label: "Overview",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "schools",
      label: "Schools",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "infrastructure",
      label: "Infrastructure",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
